import { LanguageRouter } from './components/LanguageRouter'
import { ChatBot } from './components/ChatBot'
import { SkipLink } from './components/SkipLink'
import { ChatBotProvider } from './contexts/ChatBotContext'

function App() {
  return (
    <ChatBotProvider>
      <SkipLink />
      <LanguageRouter />
      <ChatBot />
    </ChatBotProvider>
  )
}

export default App
